/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

// component
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_jutemplate/helpers'
import { ForgotPasswordVerrify } from './components/ForgotPasswordVerrify'

//image
import bg from "../../../../src/images/bg.png";
import logo from "../../../../src/assets/images/brandLogo/logo.png";

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])
//bgGradient
  return (


 
    <div
      className="d-flex vh-100 bg-light"
     >
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
        
        <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
    
    </div>
 
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      <Route path="registration" element={<Registration />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      {/* <Route
        path="forgot-password/:id"
        element={<ForgotPasswordVerrify />}
      /> */}
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
